import noop from 'lodash/noop';
import { metrics } from '@atlassian/browser-metrics';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type PerformanceMetric = any;

export const EXPAND_CHANGED = 'expand-changed' as const;
export const ADD_ITEM_CLICKED = 'add-item-clicked' as const;
export const TIMELINE_MODE_CHANGED = 'timeline-mode-changed' as const;
export const TODAY_BUTTON_CLICKED = 'today-clicked' as const;
export const EXPORT_IMAGE_GENERATED = 'exportImageGenerated' as const;

const interactionMetrics = {
	[EXPAND_CHANGED]: metrics.interaction({
		key: `jwm.timeline.${EXPAND_CHANGED}`,
	}),
	[ADD_ITEM_CLICKED]: metrics.interaction({
		key: `jwm.timeline.${ADD_ITEM_CLICKED}`,
	}),
	[TIMELINE_MODE_CHANGED]: metrics.interaction({
		key: `jwm.timeline.${TIMELINE_MODE_CHANGED}`,
	}),
	[TODAY_BUTTON_CLICKED]: metrics.interaction({
		key: `jwm.timeline.${TODAY_BUTTON_CLICKED}`,
	}),
	[EXPORT_IMAGE_GENERATED]: metrics.interaction({
		key: `jwm.timeline.${EXPORT_IMAGE_GENERATED}`,
	}),
} as const;

export type InteractionMetricType = keyof typeof interactionMetrics;

export const useInteractionMetrics = (): Record<InteractionMetricType, PerformanceMetric> =>
	interactionMetrics;

const interactionMock = { start: noop, stop: noop } as const;
export const useInteractionMetricsMock = () => ({
	[EXPAND_CHANGED]: interactionMock,
	[ADD_ITEM_CLICKED]: interactionMock,
	[TIMELINE_MODE_CHANGED]: interactionMock,
	[TODAY_BUTTON_CLICKED]: interactionMock,
	[EXPORT_IMAGE_GENERATED]: interactionMock,
});
